import { Divider } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import React, { FunctionComponent } from "react";
import styled from "styled-components";
import { downloadStore } from "./lib";

const DividerWrapper = styled("div")`
    margin-bottom: ${(props) => props.theme.spacing.unit}px;
    margin-top: ${(props) => props.theme.spacing.unit}px;
`;

interface Props {
    visibled: boolean;
}

const PowerUserTools: FunctionComponent<Props> = ({ visibled = false }) => {
    if (!visibled) {
        return null;
    }

    return (
        <>
            <DividerWrapper>
                <Divider />
            </DividerWrapper>

            <li onClick={downloadStore}>
                <GetAppIcon color="action" /> Download Store
            </li>
        </>
    );
};

export default PowerUserTools;
